<template>
  <b-modal
    ref="slackTeamModal"
    hide-footer
    centered
    title="Set your Slack Team name"
    size="sm"
  >
    <b-form @submit.prevent="saveSlackTeam">
      <b-form-group
        label="Slack Team name"
      >
        <b-form-input
          type="text"
          v-model.trim="teamName"
          autocomplete="off"
        />
      </b-form-group>
      <b-button
        :disabled="!teamName.length"
        variant="success"
        type="submit"
      >
        Save
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
  import { mapState } from 'vuex';
  // source
  import db from '@/services/db'

  let $ = window.$

  export default {
    props: ['eventBus'],
    data () {
      return {
        teamName: ''
      }
    },
    methods: {
      saveSlackTeam() {
        db.dashboards.setSlackTeam(this.$route.params.id, this.teamName)
        if (this.$refs.slackTeamModal) this.$refs.slackTeamModal.hide()
      },
    },
    created () {
      this.eventBus.$on('showSlackTeamModal', () => {
        if (this.$refs.slackTeamModal) this.$refs.slackTeamModal.show()
      })
    },
    mounted () {
      if (this.$refs.slackTeamModal) {
        $(this.$refs.slackTeamModal['$el']).appendTo('body')
      }
    },
    beforeDestroy () {
      if (this.$refs.slackTeamModal) {
        $(this.$refs.slackTeamModal['$el']).remove()
      }
    }
  }
</script>
